<template>
  <el-dialog title="人车维护" :visible.sync="dialog" width="1100px" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" center>
    <div>
      <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="120px" size="mini">
        <div class="addressBox" style="margin-bottom:-30px">
          <h4 class="title">
            <span><i class="fa fa-truck" aria-hidden="true"></i>人车信息</span>
            <el-form-item style="margin-left:16px">
              <el-button type="primary" @click="addFN" v-if="rowData.zhaoCheTD">新增</el-button>
            </el-form-item>
          </h4>
        </div>
        <el-table :data="addFrom.carLIst" ref="table" bordersize="mini" style="width: 100%" height="300" center border>
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货车号" width="270">
            <template slot="header" v-if="rowData.zhaoCheTD">
              <div><span class="red">*</span>提货车号</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.vhcNo'" :key="scope.$index" :rules="rules.vhcNo" class="table_error" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.zhaoCheTD">
                  <!-- <el-input  placeholder=""     maxlength="10"     v-model="addFrom.billCarriageInfos[scope.$index].vhcNo"></el-input> -->
                  <el-autocomplete class="inline-input" v-model.trim="addFrom.carLIst[scope.$index].vhcNo" :fetch-suggestions="querySearch" value-key="vhcNo" @select="handleSelect($event,scope.$index)" popper-class="xiala">
                    <template slot-scope="{ item }">
                      <div style="position: relative;">
                        <div class="name">{{ item.vhcNo }},{{ item.driverName }}</div>
                        <span class="addr">{{ item.driverIdentityNo? item.driverIdentityNo:''}}</span>
                        <span class="el-icon-close" style="position: absolute; right: 0;top: 4px;" @click.stop="delRenche(item)"></span>
                      </div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
                <div v-else>{{scope.row.vhcNo}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="司机姓名" width="170">
            <template slot="header" v-if="rowData.zhaoCheTD">
              <div><span class="red">*</span>司机姓名</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverName'" :key="scope.$index" :rules="rules.driverName" class="table_error" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.zhaoCheTD">
                  <el-input placeholder="" maxlength="10" v-model.trim="addFrom.carLIst[scope.$index].driverName"></el-input>
                </el-form-item>
                <div v-else>{{scope.row.driverName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份证号" min-width="170">
            <template slot="header" v-if="rowData.zhaoCheTD">
              <div><span class="red" v-if="rowData.zhanshiFlag[0]">*</span>身份证号</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverIdentityNo'" :key="scope.$index" :rules="rowData.zhanshiFlag[0]?rules.driverIdentityNo:[{required: false}]" class="table_error" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.zhaoCheTD">
                  <el-input placeholder="" maxlength="18" v-model.trim="addFrom.carLIst[scope.$index].driverIdentityNo"></el-input>
                </el-form-item>
                <div v-else>{{scope.row.driverIdentityNo}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" width="170">
            <template slot="header" v-if="rowData.zhaoCheTD">
              <div><span class="red">*</span>联系电话</div>
            </template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'carLIst.' +scope.$index+ '.driverMobile'" :key="scope.$index" :rules="rules.driverMobile" class="table_error" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.zhaoCheTD">
                  <el-input placeholder="" maxlength="11" v-model.trim="addFrom.carLIst[scope.$index].driverMobile"></el-input>
                </el-form-item>
                <div v-else>{{scope.row.driverMobile}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" v-if="rowData.zhaoCheTD">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.janFaFlag!=1" @click="carFn(scope.$index)">选择车辆</el-button>
                <el-button type="text" size="mini" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.janFaFlag!=1" @click="sijiFn(scope.$index)">选择司机</el-button>
                <el-button type="text" size="mini" v-if="(!scope.row.id||(scope.row.id&&rowData.status==1011))&&rowData.janFaFlag==1&&rowData.zhaoCheTD" @click="zhipai(scope.$index)">指派</el-button>
                <el-button type="text" size="mini" v-if="!scope.row.id" @click="delFN(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false" v-if="rowData.zhaoCheTD">取 消</el-button>
      <el-button type="primary" @click="saveFn('addFrom')" v-if="rowData.zhaoCheTD">确 定</el-button>
      <el-button type="primary" @click="dialog = false" v-if="!rowData.zhaoCheTD">关闭</el-button>
    </span>
    <!-- 选择司机 -->
    <el-dialog append-to-body title="选择司机" :visible.sync="sijiMark" @close="closeDialog1" :close-on-click-modal="false" width="900px" center>
      <!-- 内容 -->
      <div>
        <div ref="searchBox" style="margin:26px 0">
          <el-form :inline="true" :model="derverFrom" ref="derverFrom" class="demo-form-inline" label-width="86px" size="mini">
            <div class="searchBox inpBox">
              <div>
                <el-form-item label="司机姓名:" prop="name">
                  <el-input placeholder="" type="text" v-model="derverFrom.name"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="SJsearchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <!-- 表格数据 -->
        <div class="tableQiye">
          <!-- 表格 -->
          <div>
            <el-table :data="sijiList" ref="xzdz" height="500" v-loading="loading1" highlight-current-row>
              <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="sijiOK(scope.row)" size="mini">选择司机</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="name" width="120" :show-overflow-tooltip="true" label="司机姓名"></el-table-column>
              <el-table-column property="identityNo" label="身份证号" min-width="200">
                <template scope="scope">
                  <p>{{scope.row.identityNo}}</p>
                </template>
              </el-table-column>
              <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div>
        <el-pagination background @size-change="derverChange" @current-change="derverCurrentChange" :current-page="derverFrom.pageNo" :page-sizes="[25,50,100,200,1000]" :page-size="derverFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="SJtotal">
        </el-pagination>
      </div>
      <div style="width:158px;margin:15px auto;">
        <el-button type="primary" @click="sijiMark=false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 选择车辆 -->
    <el-dialog append-to-body title="选择车辆" :visible.sync="carMark" @close="closeDialog1" :close-on-click-modal="false" width="900px" center>
      <!-- 内容 -->
      <div>
        <el-form :inline="true" :model="carFrom" class="demo-form-inline" label-width="86px" size="mini">
          <div class="searchBox inpBox">
            <div>
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input placeholder="" v-model="carFrom.vhcNo"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="carSearchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <!-- 表格数据 -->
        <div class="tableQiye">
          <!-- 表格 -->
          <div>
            <el-table :data="carList" ref="table" v-loading="loading1" bordersize="mini" class="table" height="380px" style="width: 100%" center border>
              <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="vhcNo" width="100" label="车牌号"></el-table-column>
              <el-table-column prop="vhcTypeName" width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
              <el-table-column prop="weight" width="100" :show-overflow-tooltip="true" label="载重(吨)"></el-table-column>
              <el-table-column prop="energyName" width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
              <el-table-column prop="standardsName" width="80" :show-overflow-tooltip="true" label="排放标准"></el-table-column>
              <el-table-column property="vhcCompanyName" width="240" :show-overflow-tooltip="true" label="所属单位/个人"> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-pagination background @size-change="carChange" @current-change="carCurrentChange" :current-page="carFrom.pageNo" :page-sizes="[25,50,100,200,1000]" :page-size="carFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="carTotal">
      </el-pagination>
      <div style="width:158px;margin:15px auto;">
        <el-button type="primary" @click="carMark=false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 指派 -->
    <zhipai v-if="zhipaiFlag" @destroy="destroy" @zhipaiSave="zhipaiSave"></zhipai>
  </el-dialog>

</template>

<script>
import { addVirtualBillCarriageInfos, SVBdetail, sBillCarriageInfoList, sCarriageLogDelete } from '@/api/soc-stock-cosco'
import { cDlist, cVIlist } from '@/api/vgs-driver'
import zhipai from '@/views/soc-stock-cosco/inventoryMonitore/zhipai.vue'
export default {
  name: 'lookVoucher',
  components: {
    zhipai
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      zhipaiFlag: false,
      dialog: true,
      addFrom: {
        id: this.rowData.id,
        carLIst: []
      },
      tableList: [],
      rules: {
        validityTime: [{ required: true, message: '请选择有效期至', trigger: 'blur' }],
        isCarHold: [{ required: true, message: '请选择是否扣车', trigger: 'blur' }],
        driverName: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverIdentityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        driverMobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ]
      },
      // 司机列表
      loading1: false,
      sijiMark: false,
      derverFrom: {
        pageNo: 1,
        pageSize: 50
      },
      sijiList: [],
      SJtotal: 0,
      // 车辆列表
      carMark: false,
      carFrom: {
        pageNo: 1,
        pageSize: 50
      },
      carList: [],
      carTotal: 0,
      currentIndx: 0,
      carDerList: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      callback: null,
      searchStr: ''

    }
  },
  created: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    SVBdetail({ id: this.rowData.id }).then(res => {
      this.addFrom.carLIst = res.sVirtualBillExt.billCarriageInfos
      console.log(!this.rowData.zhaoCheTD)
      if (this.rowData.zhaoCheTD) {
        this.addFrom.carLIst.push({})
      }
    })

    sBillCarriageInfoList({ isDistinct: '1', billCategory: 2 }).then(res => {
      this.carDerList = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
  },
  methods: {
    // 删除下拉得人车
    delRenche (item) {
      sCarriageLogDelete({ id: item.id }).then(res => {
        sBillCarriageInfoList({ isDistinct: '1', billCategory: 2 }).then(res => {
          this.carDerList = res
          this.querySearch(this.searchStr, this.callback)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 指派
    zhipai (index) {
      this.currentIndx = index
      this.zhipaiFlag = true
    },
    zhipaiSave (row) {
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverName', row.driverName)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverMobile', row.driverMobile)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'vhcNo', row.vhcNo)
      this.zhipaiFlag = false
    },
    destroy () {
      this.zhipaiFlag = false
    },
    querySearch (str, cb) {
      let arr = []
      this.carDerList.forEach(itme => {
        if (str) {
          if (itme.vhcNo.indexOf(str) != -1) {
            arr.push(itme)
          }
        } else {
          arr.push(itme)
        }
      })
      this.callback = cb
      this.searchStr = str
      cb(arr)
    },
    handleSelect (row, index) {
      this.$set(this.addFrom.carLIst[index], 'driverName', row.driverName)
      this.$set(this.addFrom.carLIst[index], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.carLIst[index], 'driverMobile', row.driverMobile)
    },
    // 选择司机
    sijiFn (index) {
      this.sijiMark = true
      this.SJsearchFn()
      this.currentIndx = index
    },
    sijiOK (row) {
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverName', row.name)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverIdentityNo', row.identityNo)
      this.$set(this.addFrom.carLIst[this.currentIndx], 'driverMobile', row.mobile)
      this.sijiMark = false
    },
    // 选择车辆
    carFn (index) {
      this.carMark = true
      this.carSearchFn()
      this.currentIndx = index
    },
    carOk (row) {
      this.$set(this.addFrom.carLIst[this.currentIndx], 'vhcNo', row.vhcNo)
      this.carMark = false
    },
    // 添加人车
    addFN () {
      this.addFrom.carLIst.push({})
    },
    // 删除人车
    delFN (n) {
      this.addFrom.carLIst.splice(n, 1)
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          let arr = []
          let carLIst = this.addFrom.carLIst
          const ids = []
          this.addFrom.carLIst.forEach((item) => {
            if (item.driverIdentityNo) {
              ids.push(item.driverIdentityNo)
            }
            arr.push(item)
            // if (!item.id) {
            //   arr.push(item)
            // }
          })
          this.addFrom.billCarriageInfos = arr
          if (this.addFrom.billCarriageInfos.length == 0) {
            this.$alert('请维护人车信息', '系统提示')
            return
          }
          if (ids.length > 0) {
            const idsSet = new Set(ids)
            if ([...idsSet].length != ids.length) {
              this.$alert('人车信息身份证号不能重复', '系统提示')
              return
            }
          }
          delete this.addFrom.carLIst
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let that = this
          addVirtualBillCarriageInfos(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$emit('destroy')
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                that.addFrom.carLIst = carLIst
                loading.close()
              }
            })
          })
        }
      })
    },
    // 司机列表
    SJsearchFn () {
      this.getDerverList()
    },
    getDerverList () {
      this.loading1 = true
      cDlist(this.derverFrom).then(res => {
        this.loading1 = false
        this.sijiList = res.list
        this.SJtotal = res.total
      })
    },
    derverChange (val) {
      this.derverFrom.pageSize = val
      this.getDerverList()
    },
    derverCurrentChange (val) {
      this.derverFrom.pageNo = val
      this.getDerverList()
    },
    // 车辆列表
    carSearchFn () {
      this.getCarlist()
    },
    getCarlist () {
      this.loading1 = true
      cVIlist(this.carFrom).then(res => {
        this.loading1 = false
        this.carList = res.list
        this.carTotal = res.total
      })
    },
    carChange (val) {
      this.carFrom.pageSize = val
      this.getDerverList()
    },
    carCurrentChange (val) {
      this.carFrom.pageNo = val
      this.getDerverList()
    },
    // 重置
    resetForm (formName) {
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.carFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog1 () {
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.carFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card {
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content {
  flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
.table_error /deep/.el-form-item__error {
  // top: 8px;
  // left: 5px;
}

/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 6px 0 !important;
}
.xiala {
  .name {
    color: #000;
    line-height: normal;
    margin-top: 6px;
  }
  .addr {
    color: #999;
  }
}
/deep/.el-autocomplete {
  width: 210px;
}
</style>
